module.exports = __webpack_public_path__ + "img/se.6646dc9e.png";